var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateKeyConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7629",
    "data-name": "Group 7629",
    transform: "translate(-1840 -110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6676",
    "data-name": "Rectangle 6676",
    width: 50,
    height: 50,
    rx: 6,
    transform: "translate(1840 110)",
    fill: "#f2824c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M-13997.423,16091.578v-6.156h-6.156a1.42,1.42,0,0,1-1.42-1.42,1.42,1.42,0,0,1,1.42-1.42h6.156v-6.16a1.423,1.423,0,0,1,1.424-1.42,1.419,1.419,0,0,1,1.42,1.42v6.16h6.156a1.423,1.423,0,0,1,1.424,1.42,1.423,1.423,0,0,1-1.424,1.42h-6.156v6.156a1.421,1.421,0,0,1-1.42,1.423A1.425,1.425,0,0,1-13997.423,16091.578Z",
    transform: "translate(15860.999 -15949.002)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateKeyConfiguration);
export default __webpack_public_path__ + "static/media/createKeyConfiguration.8a75842614c49d3df9438503a38c0f60.svg";
export { ForwardRef as ReactComponent };